export default __webpack_public_path__ + "static/logo-2c84aea0835b52af4690215bc2a6a9af.png";